import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filteredListByArchive',
    standalone: false
})
export class FilteredListByArchivePipe implements PipeTransform {
    static format(list: Record<string, any>[], showArchived: boolean, archivedProperty: string = 'EstCloture'): Record<string, any>[] {
        return (showArchived ? list : list?.filter(f => !f[archivedProperty])) || [];
    }

    transform(list: Record<string, any>[], showArchived: boolean, archivedProperty: string = 'EstCloture'): Record<string, any>[] {
      return   FilteredListByArchivePipe.format(list, showArchived, archivedProperty);
    }

}
